import { render, staticRenderFns } from "./InternalDnsWizard.vue?vue&type=template&id=ef0fcdee&"
import script from "./InternalDnsWizard.vue?vue&type=script&lang=js&"
export * from "./InternalDnsWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports